import React, { useState, useEffect } from 'react';
import { Image } from 'antd';
import LoginFormView from './LoginFormView';
import {useCompany} from "@/hooks/company/use-company";
import { useGetLoginLogo } from "@/shared/api/client/appearance-controller";

const LoginView = () => {
    // Initialize the fetching process
    const {isLoading,isError,data,error} = useCompany();
    const { data: loginLogo } = useGetLoginLogo();
    const logoSrc = typeof loginLogo === 'string' ? loginLogo : loginLogo?.data || '/images/login.png';


    console.log("LoginView is rendered");

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isError) {
        console.error("Error in useCompany:", error);
        return <div>Something went wrong: {error.message}</div>;
    }

    if (!data) {
        return <div>No company data available.</div>;
    }

    const { brFname, brsesDate } = data;

    return (
        <div className="h-screen flex items-center">
            {/*@ts-ignore*/}
            <style jsx={"true"}>{`
                .animate-gradient {
                    @keyframes animating-background {
                        0% {
                            background-position: 0% 50%;
                        }
                        100% {
                            background-position: 100% 50%;
                        }
                    }
                }
            `}</style>
            <div className="w-full mx-auto flex flex-wrap md:flex-no-wrap">
                {/* Left Column - Company Name and Session Date */}
                <div className="animate-gradient bg-gradient-to-r from-gray-500 via-gray-550 to-gray-600 animate-gradient h-screen hidden w-full md:w-4/6 py-4 md:py-0 md:flex flex-col justify-center items-center md:items-start">
                    <div className="flex flex-col justify-center items-center w-full mb-28">
                        <Image src={logoSrc} alt="Company Logo" />
                    </div>
                    <div className="flex flex-col justify-center items-center w-full mb-72">
                        <h1 className="text-gray-100 text-3xl mb-4 font-sans">{brFname}</h1>
                        <p className="text-white font-sans">Session Date: {brsesDate}</p>
                    </div>
                </div>

                {/* Right Column - Login Form */}
                <div className="bg-gray-50 h-screen w-full md:w-2/6 flex justify-center items-center">
                    <LoginFormView />
                </div>
            </div>
        </div>
    );
};

export default LoginView;